import { createApiClient } from 'Network/ApiClient';

export const ActivityMedicalAxiosInstance = createApiClient('activitymedical/');


